(function () {
  // Ciblage robuste de la section via currentScript (fallback sur querySelector)
  const script =
    document.currentScript ||
    document.querySelector('script[src*="kea-doublecard-w-collection.js"][data-section-id]');
  const sectionId = script && script.getAttribute("data-section-id");
  const root = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : document;
  if (!root) return;

  // États internes
  const bound = new WeakMap(); // flip-card -> true si déjà bindé
  const handlers = new WeakMap(); // flip-card -> { onClick, onKeyDown, onPointerDown, onPointerMove, clearPointer }
  const dragState = new WeakMap(); // flip-card -> { x, y, moved }
  const DRAG_THRESHOLD = 6; // px pour considérer un glisser (éviter flip au scroll horizontal)
  const INTERACTIVE = 'a,button,[role="button"],input,select,textarea,label,[data-no-flip]';

  const setPressed = (card, pressed) =>
    card.setAttribute("aria-pressed", pressed ? "true" : "false");

  const isWithinSection = (el) => {
    if (!sectionId) return true; // script page-wide
    const s = el && el.closest && el.closest(`#shopify-section-${sectionId}`);
    return !!s;
  };

  function bindCard(card) {
    if (bound.get(card)) return;

    // A11y de base
    card.setAttribute("tabindex", "0");
    card.setAttribute("role", "button");
    setPressed(card, card.classList.contains("is-flipped"));

    // Flip helper
    const toggle = (e) => {
      // Ne rien faire si clic depuis un contrôle interactif ou opt-out explicite
      if (e && e.target && e.target.closest(INTERACTIVE)) return;

      // Ne pas flipper si l’utilisateur est en train de glisser (scroll horizontal)
      const s = dragState.get(card);
      if (s && s.moved) return;

      card.classList.toggle("is-flipped");
      setPressed(card, card.classList.contains("is-flipped"));
    };

    // Listeners
    const onClick = (e) => {
      if (!isWithinSection(card)) return;
      toggle(e);
      const s = dragState.get(card);
      if (s) s.moved = false; // reset après le cycle
    };

    const onKeyDown = (e) => {
      if (!isWithinSection(card)) return;
      if (e.key === "Escape") {
        card.classList.remove("is-flipped");
        setPressed(card, false);
        return;
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggle(e);
      }
    };

    const onPointerDown = (e) => {
      dragState.set(card, { x: e.clientX, y: e.clientY, moved: false });
    };
    const onPointerMove = (e) => {
      const s = dragState.get(card);
      if (!s) return;
      const dx = e.clientX - s.x;
      const dy = e.clientY - s.y;
      if (!s.moved && dx * dx + dy * dy > DRAG_THRESHOLD * DRAG_THRESHOLD) s.moved = true;
    };
    const clearPointer = () => {
      const s = dragState.get(card);
      if (s) s.moved = false;
    };

    // Bind
    card.addEventListener("click", onClick, false);
    card.addEventListener("keydown", onKeyDown, false);
    card.addEventListener("pointerdown", onPointerDown, { passive: true });
    card.addEventListener("pointermove", onPointerMove, { passive: true });
    card.addEventListener("pointerup", clearPointer, { passive: true });
    card.addEventListener("pointercancel", clearPointer, { passive: true });
    card.addEventListener("pointerleave", clearPointer, { passive: true });

    bound.set(card, true);
    handlers.set(card, { onClick, onKeyDown, onPointerDown, onPointerMove, clearPointer });
  }

  function unbindCard(card) {
    const h = handlers.get(card);
    if (!h) return;
    card.removeEventListener("click", h.onClick, false);
    card.removeEventListener("keydown", h.onKeyDown, false);
    card.removeEventListener("pointerdown", h.onPointerDown, { passive: true });
    card.removeEventListener("pointermove", h.onPointerMove, { passive: true });
    card.removeEventListener("pointerup", h.clearPointer, { passive: true });
    card.removeEventListener("pointercancel", h.clearPointer, { passive: true });
    card.removeEventListener("pointerleave", h.clearPointer, { passive: true });
    handlers.delete(card);
    bound.delete(card);
    dragState.delete(card);
  }

  function bindAll(scope) {
    (scope || root).querySelectorAll(".flip-card").forEach(bindCard);
  }
  function unbindAll(scope) {
    (scope || root).querySelectorAll(".flip-card").forEach(unbindCard);
  }

  // Bind initial
  bindAll(root);

  // Événements natifs de l'éditeur (fallback si le bridge n'est pas chargé)
  document.addEventListener("shopify:section:load", (e) => {
    if (!sectionId || `shopify-section-${sectionId}` === e.target.id) bindAll(e.target);
  });
  document.addEventListener("shopify:section:select", (e) => {
    if (!sectionId || `shopify-section-${sectionId}` === e.target.id) bindAll(e.target);
  });
  document.addEventListener("shopify:section:unload", (e) => {
    if (!sectionId || `shopify-section-${sectionId}` === e.target.id) unbindAll(e.target);
  });

  // Bridge custom (émis par assets/kea-init.js)
  document.addEventListener("kea:reinit", (e) => {
    if (!sectionId || e.detail?.sectionId === sectionId) bindAll(e.detail?.sectionEl || root);
  });
  document.addEventListener("kea:destroy", (e) => {
    if (!sectionId || e.detail?.sectionId === sectionId) unbindAll(e.detail?.sectionEl || root);
  });
})();
